import React from 'react';
import PropTypes from 'prop-types';

import './bookJacketFan.less';
import ReactImageFallback from "react-image-fallback";

const BookJacketFan = (props) => {
    return (
        <div className="fan-container">
            <div className="jacket-fan" title={props.title}>
				<ReactImageFallback alt={props.title} src={props.bookJacketUrl} className="jacket bottom-right" fallbackImage={fallBackDiv('bottom-right')} />
				<ReactImageFallback alt={props.title} src={props.bookJacketUrl} className="jacket bottom-left" fallbackImage={fallBackDiv('bottom-left')} />
				<ReactImageFallback alt={props.title} src={props.bookJacketUrl} className="jacket mid-right" fallbackImage={fallBackDiv('mid-right')} />
				<ReactImageFallback alt={props.title} src={props.bookJacketUrl} className="jacket mid-left" fallbackImage={fallBackDiv('mid-left')} />
				<ReactImageFallback alt={props.title} src={props.bookJacketUrl} className="jacket top" fallbackImage={fallBackDiv('top')} />
            </div>
        </div>
    )
};

BookJacketFan.propTypes = {
    bookJacketUrl: PropTypes.string,
    title: PropTypes.string
}

function fallBackDiv(positioningClass){
	let fallbackClassName = "no-jacket-found " + positioningClass;
	return <div className={fallbackClassName}></div>;
}

export default BookJacketFan;



// WEBPACK FOOTER //
// ./src/react/views/bookJacket/BookJacketFan.jsx